import React from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';
import get from 'lodash/get';
import Button from 'wonderbly-components/lib/Button';
import withErrors from '../../../../js/view/hocs/withErrors';

class CopyToClipboard extends React.Component {
  constructor(props) {
    super(props);
    this.button = React.createRef();
    this.state = {
      text: this.props.text,
      colour: 'green',
    };
  }

  componentDidMount() {
    this.setupClipboard();
  }

  setupClipboard() {
    const button = this.button.current;
    this.clipboard = new Clipboard(button);

    // Update the text on successfull copy to clipboard
    this.clipboard.on('success', () => {
      const originalState = {
        text: this.props.text,
        colour: 'green',
      };

      this.setState({
        text: this.props.successText,
        colour: 'green-dark'
      }, () => {
        // setState callback which is called once state is actually updated
        this.resetSuccessTimeout = setTimeout(() => this.setState(originalState), 3000);
      });
    });

    this.clipboard.on('error', () => {
      this.setState({
        text: get(this.props, 'errors.general.copyToClipboard', ''),
        colour: 'green-dark',
      });
    });
  }

  componentWillUnmount() {
    this.clipboard.destroy();
    clearTimeout(this.resetSuccessTimeout);
  }

  render() {
    return (
      <div
        ref={this.button}
        data-clipboard-text={this.props.value}>
        <Button
          colour={this.state.colour}
          raised>
          {this.state.text}
        </Button>
      </div>
    );
  }
}

CopyToClipboard.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string,
  successText: PropTypes.string.isRequired,
  errors: PropTypes.shape({
    general: PropTypes.shape({
      copyToClipboard: PropTypes.string.isRequired,
    })
  })
};

export default withErrors(CopyToClipboard);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CopyToClipboard/CopyToClipboard.js